module.exports = __webpack_public_path__ + "img/ic_sign_up_promo_code.29932f0c.svg";